import { render } from "./LoginCode.vue?vue&type=template&id=85cc634a"
import script from "./LoginCode.vue?vue&type=script&lang=js"
export * from "./LoginCode.vue?vue&type=script&lang=js"

import exportComponent from "/builds/nordhealth/projects/therapy/easypractice/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__